import React, { useState } from 'react';
import { Button, Divider, Modal, TextAreaField } from '@placer-ui/components';
import { useOfflineReportsActions } from 'store/offline-reports/use-offline-reports-actions';
import { TitleModalHeader } from 'features/my-zone/support-requests/components/support-requests-modals/components/title-modal-header/title-modal-header';
import styles from './xtra-request-message-modal.module.scss';
import { useOpenSupportRequest } from 'features/my-zone/support-requests/components/support-requests-modals/support-modal-manager';
import { OrderManagementRequest } from 'core/entities';
import { XtraRequestComment } from '../xtra-request-comment/xtra-request-comment';

export type XtraMessageRequestProps = {
    selectedRequest: OrderManagementRequest;
};

export const XtraRequestsMessageModal = ({ selectedRequest }: XtraMessageRequestProps) => {
    const { comments } = selectedRequest;
    const [newComment, setNewComment] = useState('');
    const { postOfflineReportsRequestsComment } = useOfflineReportsActions();
    const { openSupportRequest } = useOpenSupportRequest();
    const { id, subject } = selectedRequest;
    const [isPostingMsg, setIsPostingMsg] = useState(false);
    const sendMessage = async () => {
        setIsPostingMsg(true);

        await postOfflineReportsRequestsComment({
            requestId: id,
            payload: { comment: newComment },
        });

        openSupportRequest({ flowType: 'xtraInfo', props: { requestId: id } });
        setIsPostingMsg(false);
    };

    return (
        <>
            <div className={styles.titleModalWrapper}>
                <TitleModalHeader title={subject} />
            </div>
            <Modal.Content>
                <div className={styles.modalBody}>
                    {comments.length > 0 && (
                        <>
                            <div className={styles.comments}>
                                <XtraRequestComment comment={comments[comments.length - 1]} />
                            </div>
                            <Divider />
                        </>
                    )}
                    <TextAreaField
                        value={newComment}
                        onChange={setNewComment}
                        label="Reply a message on this thread"
                        placeholder="Write your message here"
                        initialHeight={104}
                    />
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Modal.Footer.RightControls>
                    <Button
                        testId="xtra-request-message-modal-cancel-button"
                        variant="secondary-blue"
                        fullWidth
                        onClick={() =>
                            openSupportRequest({ flowType: 'xtraInfo', props: { requestId: id } })
                        }
                        disabled={isPostingMsg}
                    >
                        Cancel
                    </Button>
                    <Button
                        testId="xtra-request-message-modal-submit-button"
                        variant="primary-brand"
                        fullWidth
                        onClick={sendMessage}
                        disabled={isPostingMsg || !newComment}
                        isLoading={isPostingMsg}
                    >
                        {!isPostingMsg && 'Send a Message'}
                    </Button>
                </Modal.Footer.RightControls>
            </Modal.Footer>
        </>
    );
};
